import { Component, Prop, Element, Host, h } from '@stencil/core';
import { Color } from '../../../interface';
import { createColorClasses } from '../../../utils/theme';

@Component({
  tag: 'lar-button',
  styleUrl: 'button.scss',
  shadow: true
})
export class LarvaButton {
  @Element() el!: HTMLElement;
  /**
   * The color to use from your application's color palette.
   * Default options are: `"primary"`, `"secondary"`, `"tertiary"`, `"success"`, `"warning"`, `"danger"`, `"light"`, `"medium"`, and `"dark"`.
   */
  @Prop() color?: Color;
  /**
   * outline styled button
   */
  @Prop() outline?: boolean = false;
  /**
   * size
   */
  @Prop() size?: ('small' | 'default') = 'default';

  /**
   * expand
   */
  @Prop() expand?: ('full' | 'block') = 'full';

  /**
   * If `true`, the user cannot interact with the button.
   */
  @Prop({ reflect: true }) disabled = false;

  render() {
    return (
      <Host
        class={{
        ...createColorClasses(this.color),
        'lar-button': true,
        'lar-button-disabled': this.disabled,
        'lar-button-outline': this.outline,
        'lar-button-small': this.size === 'small',
        'lar-button-full': this.expand === 'full'
        }}
      >
        <button disabled={this.disabled}><slot/></button>
      </Host>
    );
  }
}
